import Vue from 'vue';

// el-buttonの@clickにフォーカスを外す処理を追加したラップコンポーネント
// el-buttonでは@clickの処理後にフォーカスが外れないことがあるので作成
export default Vue.extend({
  name: 'ElwButton',

  props: {
    size: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    plain: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    nativeType: {
      type: String,
      default: 'button',
    },
  },

  methods: {
    click(event: PointerEvent): void {
      this.$emit('click');
      const elem = event.currentTarget as HTMLButtonElement;
      if (elem !== null) elem.blur();
    },
  },
});
